import { z } from 'zod';
/**
 * Fluxos de atendimento (o "robozinho" da triagem).
 *
 * Ciclo: rascunho → publicar → versão imutável. Conversas em andamento continuam na versão
 * em que começaram, então publicar nunca quebra quem já está no meio do atendimento.
 * A definição do grafo (nós e arestas) vive em @mymaxx/flow-engine.
 */
export const GatilhoFluxo = {
    /** Roda quando o cliente inicia um atendimento (triagem). */
    ENTRADA: 'entrada',
    /** Roda ao entrar em um setor específico. */
    SETOR: 'setor',
    /** Roda quando o setor está fora do horário. */
    FORA_HORARIO: 'fora_horario',
    /** Só é acionado de propósito (transferir_fluxo ou teste). */
    MANUAL: 'manual',
};
export const ROTULO_GATILHO = {
    entrada: 'Início do atendimento',
    setor: 'Ao entrar no setor',
    fora_horario: 'Fora do horário',
    manual: 'Somente manual',
};
export const fluxoFormSchema = z.object({
    nome: z.string().trim().min(2, 'Informe o nome do fluxo').max(80),
    descricao: z.string().trim().max(300).optional().or(z.literal('')),
    gatilho: z.enum(['entrada', 'setor', 'fora_horario', 'manual']).default('manual'),
    ativo: z.boolean().default(true),
});
/** O rascunho é salvo como veio do editor; a validação acontece ao publicar. */
export const rascunhoSchema = z.object({
    definicao: z.unknown(),
});
// ---- simulador --------------------------------------------------------------
export const iniciarSimulacaoSchema = z.object({
    /** Usa o rascunho (padrão) ou a versão publicada. */
    usarRascunho: z.boolean().default(true),
});
export const mensagemSimulacaoSchema = z.object({
    sessaoId: z.string().min(1),
    texto: z.string().min(1).max(1000),
});
//# sourceMappingURL=fluxos.js.map